module.exports = __webpack_public_path__ + "img/android-chrome-512x512-3.f41f1b29.png";